module.exports = __webpack_public_path__ + "7efda276bb50e1a5abeb02aa0eee712a.pdf";